import axios from "axios";
import Vue from 'vue'; // 引入 Vue 实例，用于访问 $bus
import QS from "qs";
import "./security.js";
import crypto from '@/utils/cryptoJS.js'
import encryptionInterfaceData from './encryptionInterface.js' // 参数加密接口路径
import store from "../store/store";
if (location.href.indexOf("uuid") != -1) {
  axios.defaults.withCredentials = true;
}
let encryptionInterface = encryptionInterfaceData;
let newEncryptionInterface = [
    '/member/index/getUserInfo',
    '/member/spc/v1/getConfig',
    '/member/spc/v1/get_bind_account/',
    '/neweb-order/v2/getPayType/productId/',
    '/neweb-order/v1/orders/page/list',
    '/neweb-order/v1/generteOrder/pay',
    '/neweb-order/v2/getPayType/orderCode',
    '/neweb-order/order/v1/getInvoiceOrderList',
    '/member/spc/v1/authentication/latestDetail',
    '/neweb-order/v1/orderAndItems/iden/',
    '/neweb-product/v1/getUserPurchasedResource',
    '/member/spc/1/collectFolder/search',
    '/member/spc/v1/memberBehavior/search',
    '/member/spc/v1/memberBehavior/delete',
    '/neweb-invoice/neweb/invoiceDetail/v1/getInvoiceInfo',
    '/neweb-order/neweb/payInvoManage/v1/getPayInvoManageInfo',
    '/neweb-order/v1/order-detail/',
    '/neweb-order/v1/selectOrderStatus',
    '/neweb-product/neweb/rechargeCard/v1/activeRecharge.do',
    '/baas-auth/v1/usermembers',
    '/baas-auth/v1/resources/buyed',
    '/baas-auth/v1/usermember/isrenew',
    '/member/spc/v1/files/getFilePath',
    '/member/spc/v1/getFeedbackListPageable',
    '/member/spc/v1/saveFeedback'
]
// 开发环境下不加密接口，方便调试
if (process.env.NODE_ENV === 'development') {
  encryptionInterface = []
  newEncryptionInterface = []
}

encryptionInterface = [...encryptionInterface, ...newEncryptionInterface]

console.log(encryptionInterface, process.env.NODE_ENV)
axios.interceptors.request.use(config => {
  // 写入取消请求的标识
  config.cancelToken = new axios.CancelToken(cancel => {
    store.commit('addCancelToken', cancel)
  })

  // 给每个接口添加token, 如果token存在，赋值到headers,不能再外面定义，进入请求获取之后再获取token
  // config.headers.appId = '2222'
  // config.url = hex_url(config.url, config.method)
  if (localStorage.getItem("uuid")) {
    config.headers.uuid = localStorage.getItem("uuid");
  }
  if (localStorage.getItem("userToken")) {
    config.headers.token = localStorage.getItem("userToken");
  }
  if (sessionStorage.getItem("token") || getUrlParams('token')) {
    config.headers.authToken =  sessionStorage.getItem("token") || getUrlParams('token');
    // config.headers.authToken = '7011f1993e204e1bb2925e7f1d6db28e'; //本地开发使用  打包时注释掉
    if (
      location.href.indexOf("localhost") != -1 ||
      location.href.indexOf("192.168") != -1
    ) {
      // config.headers.appId = '8219'
    }
    // vip会员模块
    if (config.url.indexOf("CommonApi") != -1 && location.href.indexOf("offprint") == -1) {
      // 获取读者俱乐部的接口 如果有specids 就是获取下载量等，需要修改queryType\
      if (config.data && config.data.productId) {
        config.headers.queryType = "query_vip_sku_info";
      } else if (config.data && config.data.resId) {
        config.headers.queryType = "query_product_detail_info";
      } else if (config.data && config.data.type) {
        config.headers.queryType = "query_vip_product_list";
        delete config.data.type
      } else if (config.data && config.data.id) {
        config.headers.queryType = "query_vip_product_list";
      } else if (config.data && config.data.resourceId && config.data.code) { // 合集集锦 > 选购合集 > 订单
        config.headers.queryType = "query_product_info";
      } else {
        config.headers.queryType = "query_product_list";
      }
    }
    // 机构模块 || 最近阅读
    if (
      config.url.indexOf("common") != -1 &&
      config.url.indexOf("invoice") == -1
    ) {
      if (!config.headers.queryType) {
        if (
          config.url.indexOf("queryString") != -1 ||
          config.params.queryString
        ) {
          config.headers.queryType = "queryStringSearch";
        } else if (config.params.getSite) {
          config.headers.queryType = "getSite";
          delete config.params.getSite;
        } else if (config.params.getIssueparam) {
          config.headers.queryType = "getIssue";
          delete config.params.getIssueparam;
        } else if (config.params.type) {
          config.headers.queryType = "directoryGraphql";
          delete config.params.type;
        } else {
          config.headers.queryType = "dataBase";
        }
      }
    }
    if (config.url.indexOf("user_third_login") != -1 && config.url.indexOf("weibo") != -1) {
      config.headers['Content-Type'] = 'application/json'
    }
    if (config.url.indexOf("SpcMemberCancel/status") != -1) {
      config.headers['Content-Type'] = 'application/json'
    }
  }
  config.headers.appId = 100;
  return config;
});
// 响应拦截
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据;否则的话抛出错误
    if (response.status == 200 || response.status == 201) {
      if ((response.data.status == 100102 || response.data.status == 100101)) { //  登录失效
        Vue.prototype.$bus.$emit('logout', 2);
      } else if (response.data.status === 100112) { //
        Vue.prototype.$bus.$emit('logout', 1);
        let url =
            window.location.protocol +
            "//" +
            window.location.host +
            "/LoginSignOUT?userId=" + localStorage.getItem("memberId") + "&token=" + window.sessionStorage.getItem("token");
        if (!window.location.href.includes("/LoginSignOUT")) {
          location.href = url
        }
      } else if (response.data.status === 100113) {
        Vue.prototype.$bus.$emit('logout', 2);
        // location.href = localStorage.getItem("casLogin")
      }
      return Promise.resolve(response);
    } else if (response.status == 100101) {
      Vue.prototype.$bus.$emit('logout', 2);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 404:
          break;
        case 401:
          break;
        case 400:
          break;
        default:
      }
      return Promise.reject(error.response);
    }
  }
);
function getUrlParams(key) {
	let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
	let r = window.location.search.substr(1)
		.match(reg);
	if (r != null)
		return unescape(r[2]);
	return null;
}
export function Post(url, params, type, configs) {
  return new Promise((resolve, reject) => {
    if (type !== 'formData') {
      params = type == "isJson" ? params : QS.stringify(params);
    }
    let urls = url
    // 查询加密接口路径，需要给参数设置成加密的
    if (encryptionInterface.some(item => url.includes(item))) {
      let query = url.split('?')[1]
      // 处理地址栏参数
      if (query) {
        
        urls = url.split('?')[0] + '?p=' + encodeURIComponent(crypto.set(query, 'AD42F6697B035B7580E4FEF93BE20BAD'))
      }
      // 处理body参数
      if (params) {
        let a = {
          b: encodeURIComponent(crypto.set(JSON.stringify(params), 'AD42F6697B035B7580E4FEF93BE20BAD'))
        }
        console.log(a, 'post加密接口参数', params)
        params = a
      }
    }
    console.log(params, '参数')
    axios
      .post(urls, params, configs)
      .then(res => {
        if (res.data == 401) {
          if (location.href.indexOf('getPass') !== -1) {
            return
          }
          if (location.href.indexOf('reg') !== -1) {
            return
          }
          let url = encodeURIComponent(location.href);
          console.log(url, 'url--Post');
          let codes =
            window.location.protocol +
            "//" +
            window.location.host +
            "/member/cas/auth?redirectUrl=" +
            url;
          console.log(codes, 'codes--Post');
          console.log(localStorage.getItem("casLogin") + "?service=" + encodeURIComponent(codes), '跳转的地址--Post');
          location.href =
            localStorage.getItem("casLogin") + "?service=" + encodeURIComponent(codes);
          store.commit("clearCancelToken");
          localStorage.removeItem("addLoginNameId");
          localStorage.removeItem("time");
          localStorage.removeItem("memberId");
          localStorage.removeItem("addLoginName");
          localStorage.removeItem("loginName");
          localStorage.removeItem("gy");
          localStorage.removeItem("uuid");
          sessionStorage.clear();
        } else {
          // 查询加密接口路径，需要给返回值解密
          console.log(urls, '加密接口路径')
          if (encryptionInterface.some(item => urls.includes(item))) {
            if (res && res.data && res.data.data) {
              res.data.data = cryptoGetFn(res.data.data, urls)
            } else if (res && res.data) {
              res.data = cryptoGetFn(res.data, urls)
            }
            if (urls.includes('getMemberDetail.do')) {
            console.log(res.data, '解密后的数据')
            }
          }
          resolve(res.data);
        }
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
export function Get(url, params, configs) {
  params = params
  return new Promise((resolve, reject) => {
    let a = location.href.indexOf("&ticket=");
    let b = location.href.indexOf("#/personal");
    let tick = location.href.substring(a + 8, b);
    let urls = url
    // 查询加密接口路径，需要给参数设置成加密的
    if (encryptionInterface.some(item => url.includes(item))) {
      let query = QS.parse(url.split('?')[1])
      query = {
        ...query,
        ...params
      }
      if (query && Object.keys(query).length > 0) {
        params = {
          p: encodeURIComponent(crypto.set(QS.stringify(query, { encode: false }), 'AD42F6697B035B7580E4FEF93BE20BAD'))
        }
      }
      urls = url.split('?')[0]
      console.log(params, '加密参数', query, '原参数', urls, '路径', QS.stringify(query, { encode: false }));
    }
    axios
      .get(urls, {
        params: params,
        ...configs
      })
      .then(res => {
        // $encryptionAES
        if (res && res.data == 401) {
          if (location.href.indexOf('getPass') !== -1) {
            return
          }
          if (location.href.indexOf('reg') !== -1) {
            return
          }
          if (location.href.indexOf('offprint') !== -1) {
            return
          }
          let url = encodeURIComponent(location.href);
          console.log(url, 'url--get');
          let codes =
            window.location.protocol +
            "//" +
            window.location.host +
            "/member/cas/auth?redirectUrl=" +
            url;
          console.log(codes, 'codes--get');
          console.log(localStorage.getItem("casLogin") + "?service=" + codes, '跳转的地址--get');
          location.href =
            localStorage.getItem("casLogin") + "?service=" + encodeURIComponent(codes);
          store.commit("clearCancelToken");
          localStorage.removeItem("addLoginNameId");
          localStorage.removeItem("time");
          localStorage.removeItem("memberId");
          localStorage.removeItem("addLoginName");
          localStorage.removeItem("loginName");
          localStorage.removeItem("gy");
          localStorage.removeItem("uuid");
          sessionStorage.clear();
        }
        // 查询加密接口路径，需要给返回值解密
        if (encryptionInterface.some(item => url.includes(item))) {
          if (res && res.data && res.data.data) {
            res.data.data = cryptoGetFn(res.data.data, urls)
          } else if (res && res.data) {
            res.data = cryptoGetFn(res.data, urls)
          }
          console.log(res.data, '解密后的数据', urls)
        }
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

export function Delete(url, params, configs) {
  params = params
  return new Promise((resolve, reject) => {
    let urls = url
    // 查询加密接口路径，需要给参数设置成加密的
    if (encryptionInterface.some(item => url.includes(item))) {
      let query = QS.parse(url.split('?')[1])
      query = {
        ...query,
        ...params.params
      }
      console.log(query, '加密参数处理delete')
      params.params = {
        p: encodeURIComponent(crypto.set(QS.stringify(query), 'AD42F6697B035B7580E4FEF93BE20BAD'))
      }
      urls = url.split('?')[0]
    }
    axios
      .delete(urls, {
        ...params,
        ...configs
      }).then(res => {
        // 查询加密接口路径，需要给返回值解密
        if (encryptionInterface.some(item => url.includes(item))) {
          if (res && res.data && res.data.data) {
            res.data.data = cryptoGetFn(res.data.data, urls)
          } else if (res && res.data) {
            res.data = cryptoGetFn(res.data, urls)
          }
          console.log(res.data, '解密后的数据delete')
        }
        resolve(res.data);

      }).catch(err => {
        resolve(err.data);
      })
  })
}

export function $Put(url, data, configs) {
  return new Promise((resolve, reject) => {
    axios.put(url, data, {
        ...configs
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        resolve(err.data);
      })
  })
}
// 返回值解密处理
function cryptoGetFn(res, urls) {
  let data = ''
  try {
    data = JSON.parse(crypto.get(res, 'AD42F6697B035B7580E4FEF93BE20BAD'))
  } catch (e) {
    data = crypto.get(res, 'AD42F6697B035B7580E4FEF93BE20BAD')
  }
  console.log(data, '解密数据以及接口路径', urls)
  return data
}
console.log(cryptoGetFn('8UDlhJxMfQINMTn7+Trnm4ZF2gUu5myRwOBF60s4Q+bAeGWKjj7BEw43ChXN/Qt8jLzvKQuIj8kydNRjQXgUMF5EElEr1yTwljrdEVUzYCA='), '解密数据11')
// var Get = axios.get
// var Post = axios.post
var Put = axios.put;
// var Delete = axios.delete;

export { Put };



// WEBPACK FOOTER //
// ./src/api/axios.js